import React, { useEffect, useState } from "react";
import AdminLayout from "../layout/AdminLayout";
import toast from "react-hot-toast";
import Loader from "../layout/Loader";
import { useDeleteReviewMutation, useLazyGetProductReviewsQuery } from "../../redux/api/productsApi";

const ProductReviews = () => {
  const [productId, setProductId] = useState("");

  const [getProductReviews, { data, isLoading, error }] = useLazyGetProductReviewsQuery();
  const [deleteReview, { error: deleteError, isLoading: isDeleteLoading, isSuccess }] =
    useDeleteReviewMutation();

  useEffect(() => {
    if (error) toast.error(error?.data?.message);
    if (deleteError) toast.error(deleteError?.data?.message);
    if (isSuccess) toast.success("Review Deleted Successfully!");
  }, [error, deleteError, isSuccess]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (!productId.trim()) {
      toast.error("Please enter a Product ID.");
      return;
    }
    getProductReviews(productId);
  };

  const deleteReviewHandler = (id) => {
    deleteReview({ productId, id });
  };

  const reviews = Array.isArray(data?.reviews) ? data.reviews : [];

  if (isLoading) return <Loader />;

  return (
    <AdminLayout>
      <main className="container-fluid  py-4 mt-0 pt-0">
        <div
          className="cart-card p-4 rounded-4 shadow-sm col-12 col-md-8 col-lg-6 bg-body"
          style={{ fontFamily: "Quicksand, sans-serif" }}
        >
          <form onSubmit={submitHandler}>
            <h2
              className="mb-4 text-center fw-bold"
              style={{ color: "#e04f6e" }}
            >
              Product Reviews
            </h2>

            <div className="mb-3">
              <label
                htmlFor="productId_field"
                className="form-label fw-semibold"
                style={{ color: "#e04f6e" }}
              >
                Enter Product ID
              </label>
              <input
                type="text"
                id="productId_field"
                className="form-control rounded-3 p-2"
                placeholder="Enter product ID"
                value={productId}
                onChange={(e) => setProductId(e.target.value)}
              />
            </div>

            <button
              id="search_button"
              type="submit"
              className="btn w-100 py-2 fw-semibold View-btn"
            >
              SEARCH
            </button>
          </form>
        </div>
      </main>

      {/* Reviews List (ListReviews-like) */}
      {reviews.length > 0 && (
        <div className="container pb-5">
          <div className="card shadow-sm border-0 p-4" style={{ borderRadius: 16 }}>
            <h4 className="mb-3 fw-bold" style={{ color: "#e04f6e" }}>Product Reviews</h4>
            <hr />
            {reviews.map((review) => (
              <div key={review?._id} className="py-3 border-bottom">
                <div className="d-flex align-items-start justify-content-between" style={{ gap: 12, flexWrap: 'wrap' }}>
                  <div className="d-flex align-items-start" style={{ gap: 12 }}>
                    <img
                      src="/images/default_avatar.jpg"
                      alt={review?.user?.name || "User"}
                      width="50"
                      height="50"
                      style={{ borderRadius: '50%', border: '1px solid #eee', flex: '0 0 auto' }}
                    />
                    <div style={{ minWidth: 200 }}>
                      <div className="d-flex align-items-center mb-1" style={{ flexWrap: 'wrap' }}>
                        {[...Array(5)].map((_, i) => (
                          <i
                            key={i}
                            className="fa fa-star"
                            style={{ color: i < (review?.rating || 0) ? '#ffb829' : '#c0c4cc', marginRight: 4 }}
                          ></i>
                        ))}
                      </div>
                      <p className="mb-1 fw-semibold" style={{ color: '#333', wordBreak: 'break-word' }}>
                        {review?.user?.name || 'Anonymous'}
                      </p>
                      <p className="small mb-0" style={{ color: '#666', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                        {review?.comment || 'No comment provided.'}
                      </p>
                      <div className="small text-muted mt-2"><strong>ID:</strong> {review?._id}</div>
                    </div>
                  </div>
                  <div>
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => deleteReviewHandler(review?._id)}
                      disabled={isDeleteLoading}
                      title="Delete review"
                    >
                      <i className="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </AdminLayout>
  );
};

export default ProductReviews;
